import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

export const createScrollSlice = (set: SetState<AskPerformYardState>) => ({
	scrollToBottom: null as (() => void) | null,
	setScrollToBottom: (fn: (() => void) | null) => set({ scrollToBottom: fn }),
});
